module.exports = __webpack_public_path__ + "assets/img/2.d956b458.jpg";